import { Components } from "@mui/material/styles";

export const MuiDivider: Components["MuiDivider"] = {
    styleOverrides: {
        root: {
            borderColor: "var(--mui-palette-gray-100)",
            "&::before, &::after": {
                borderColor: "inherit",
            },
        },
    },
};
